module.exports = __webpack_public_path__ + "static/media/23-6.fa0d7833.mp3";